import { render, staticRenderFns } from "./carousel-item.vue?vue&type=template&id=15948e81&"
import script from "./carousel-item.vue?vue&type=script&lang=js&"
export * from "./carousel-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15948e81')) {
      api.createRecord('15948e81', component.options)
    } else {
      api.reload('15948e81', component.options)
    }
    module.hot.accept("./carousel-item.vue?vue&type=template&id=15948e81&", function () {
      api.rerender('15948e81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/carousel/carousel-item.vue"
export default component.exports